module.exports = __webpack_public_path__ + "static/14-7a3dcf6cf85b686192b0fd13234b6311.jpg";